import { rootRoute } from './root'
import { homeRoute } from './home'
import { categoryRoute } from './category'
import { topicRoute } from './topic'

export const communityRoute = rootRoute.addChildren([homeRoute, categoryRoute, topicRoute])
